module.exports = __webpack_public_path__ + "static/media/deleteIcon.a914fdda.png";